import { render, staticRenderFns } from "./FatHeader.vue?vue&type=template&id=512008c9&scoped=true"
import script from "./FatHeader.vue?vue&type=script&lang=js"
export * from "./FatHeader.vue?vue&type=script&lang=js"
import style0 from "./FatHeader.vue?vue&type=style&index=0&id=512008c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512008c9",
  null
  
)

export default component.exports